import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "../views/Home.vue";
import ExamplePage from "../views/Example.vue";
import DownloadPage from "../views/Download.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: HomePage,
	},
	{
		path: "/example",
		name: "Example",
		component: ExamplePage,
	},
	{
		path: "/download",
		name: "Download",
		component: DownloadPage,
	},
];

const router = new VueRouter({
	routes,
	mode: "history",
});

export default router;
